/*
  Comportamiento de la PDP de Costa Sneakers.

  Cubre los 12 estados del Figma que no se pueden resolver solo con CSS:
  seleccion de talla, aviso de escasez, error por falta de talla, barra fija,
  guia de tallas y caja de regalo.

  Nota importante sobre el ciclo de vida:
  product-info.js reemplaza el nodo <product-info> ENTERO al cambiar de variante,
  y al hacerlo vuelve a inyectar y ejecutar este mismo script. Por eso:
  - los escuchadores globales se registran una sola vez, por delegacion en
    document, y sobreviven al reemplazo;
  - lo que si depende de nodos concretos (el IntersectionObserver de la barra
    fija) se vuelve a montar en cada ejecucion.
*/

(function () {
  'use strict';

  var SELECTORS = {
    productInfo: 'product-info[id^="MainProduct"]',
    config: '[data-costa-config]',
    sizeInput: '[data-size-input]',
    sizeGroup: '.costa-variants__group--size',
    scarcity: '[data-costa-scarcity]',
    sizeError: '[data-costa-size-error]',
    addButton: '[data-costa-add-button]',
    sticky: '[data-costa-sticky]',
    stickyButton: '[data-costa-sticky-button]',
    guideDialog: '[data-costa-size-guide]',
    guideOpen: '[data-costa-size-guide-open]',
    guideClose: '[data-costa-size-guide-close]',
    addon: '[data-costa-addon]',
    addonInput: '[data-costa-addon-input]',
    galleryTrack: '[data-costa-gallery-track]',
    galleryThumb: '[data-costa-gallery-thumb]',
    galleryCounter: '[data-costa-gallery-counter]',
    galleryDots: '[data-costa-gallery-dots]',
    galleryZoom: '[data-costa-gallery-zoom]',
    lightbox: '[data-costa-lightbox]',
    lightboxImg: '[data-costa-lightbox-img]',
    lightboxClose: '[data-costa-lightbox-close]'
  };

  var stickyObserver = null;

  /* ----------------------------------------------------------------
     Utilidades
     ---------------------------------------------------------------- */

  function root() {
    return document.querySelector(SELECTORS.productInfo);
  }

  function config() {
    var node = document.querySelector(SELECTORS.config);
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  }

  function checkedSize() {
    return document.querySelector(SELECTORS.sizeInput + ':checked');
  }

  /* ----------------------------------------------------------------
     Estados 01, 02, 04, 05 y 06 · talla y escasez

     El aviso de escasez sigue esta prioridad:
     1. Si el producto no tiene ninguna talla disponible -> aviso de agotado.
     2. Si hay una talla elegida y le queda poco -> se nombra esa.
     3. Si no hay talla elegida -> se nombra la talla con menos unidades, que es
        justamente la que aparece pintada en ambar en la reticula.
     Nunca se inventa un numero: si Shopify no hace seguimiento de inventario, el
     dato no existe y el aviso no aparece.
     ---------------------------------------------------------------- */

  function syncSizeState() {
    var group = document.querySelector(SELECTORS.sizeGroup);
    if (!group) return;

    var scarcityNode = group.querySelector(SELECTORS.scarcity);
    if (!scarcityNode) return;

    var inputs = Array.prototype.slice.call(group.querySelectorAll(SELECTORS.sizeInput));
    var available = inputs.filter(function (input) {
      return !input.disabled;
    });

    if (inputs.length && !available.length) {
      group.classList.add('is-out-of-stock');
      scarcityNode.textContent =
        group.getAttribute('data-scarcity-none') || 'Sin stock por ahora';
      scarcityNode.hidden = false;
      return;
    }

    group.classList.remove('is-out-of-stock');

    var settings = config();
    var threshold = settings.lowStockThreshold || 2;

    var target = null;
    var selected = checkedSize();

    if (selected && !selected.disabled && selected.hasAttribute('data-inventory')) {
      target = selected;
    } else if (!selected) {
      available.forEach(function (input) {
        if (!input.hasAttribute('data-inventory')) return;
        var units = parseInt(input.getAttribute('data-inventory'), 10);
        if (isNaN(units) || units <= 0 || units > threshold) return;
        if (!target || units < parseInt(target.getAttribute('data-inventory'), 10)) {
          target = input;
        }
      });
    }

    if (!target) {
      scarcityNode.hidden = true;
      scarcityNode.textContent = '';
      return;
    }

    var remaining = parseInt(target.getAttribute('data-inventory'), 10);
    if (isNaN(remaining) || remaining <= 0 || remaining > threshold) {
      scarcityNode.hidden = true;
      scarcityNode.textContent = '';
      return;
    }

    var template =
      remaining === 1
        ? group.getAttribute('data-scarcity-one')
        : group.getAttribute('data-scarcity-many');

    if (!template) {
      template = remaining === 1 ? 'Queda {n} en talla {s}' : 'Quedan {n} en talla {s}';
    }

    scarcityNode.textContent = template
      .replace('{n}', remaining)
      .replace('{s}', target.getAttribute('data-value') || target.value);
    scarcityNode.hidden = false;
  }

  function clearSizeError() {
    var group = document.querySelector(SELECTORS.sizeGroup);
    if (!group) return;
    group.classList.remove('is-error');
    var error = group.querySelector(SELECTORS.sizeError);
    if (error) error.hidden = true;
  }

  /* ----------------------------------------------------------------
     Estado 03 · sin talla y clic en el CTA

     El boton no se deshabilita a proposito: al pulsarlo se enseña que falta un
     paso, en vez de dejar al comprador frente a un boton muerto sin explicacion.
     ---------------------------------------------------------------- */

  function showSizeError() {
    var group = document.querySelector(SELECTORS.sizeGroup);
    if (!group) return;

    group.classList.add('is-error');
    var error = group.querySelector(SELECTORS.sizeError);
    if (error) error.hidden = false;

    var firstAvailable = group.querySelector(SELECTORS.sizeInput + ':not(:disabled)');
    if (firstAvailable) firstAvailable.focus();

    group.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function needsSize() {
    var group = document.querySelector(SELECTORS.sizeGroup);
    if (!group) return false;
    if (!group.querySelector(SELECTORS.sizeInput)) return false;
    return !checkedSize();
  }

  /* ----------------------------------------------------------------
     Estado 12 · barra fija de compra

     Solo aparece cuando el CTA ya quedo POR ENCIMA de la pantalla. Con la
     condicion simple de "no visible" la barra saldria nada mas cargar, porque
     al principio el boton todavia esta por debajo del pliegue.
     ---------------------------------------------------------------- */

  function mountStickyBar() {
    if (stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }

    var bar = document.querySelector(SELECTORS.sticky);
    var button = document.querySelector(SELECTORS.addButton);
    if (!bar || !button || !('IntersectionObserver' in window)) return;

    stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
          bar.hidden = !scrolledPast;
        });
      },
      { threshold: 0 }
    );

    stickyObserver.observe(button);
    syncStickyButton();
  }

  function syncStickyButton() {
    var button = document.querySelector(SELECTORS.stickyButton);
    if (!button) return;

    if (needsSize()) {
      button.textContent = 'Elegir talla';
      button.classList.add('costa-sticky__button--outline');
    } else {
      button.textContent = 'Agregar';
      button.classList.remove('costa-sticky__button--outline');
    }
  }

  /* ----------------------------------------------------------------
     Guia de tallas
     ---------------------------------------------------------------- */

  function openGuide() {
    var dialog = document.querySelector(SELECTORS.guideDialog);
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeGuide() {
    var dialog = document.querySelector(SELECTORS.guideDialog);
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  /* ----------------------------------------------------------------
     Caja de regalo

     Es un producto real: entra con /cart/add.js y sale con /cart/change.js en
     cantidad 0. Si la peticion falla se devuelve la casilla a su estado
     anterior, para que nunca diga una cosa distinta de lo que hay en el carrito.
     ---------------------------------------------------------------- */

  function refreshCartDrawer(shouldOpen) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();

    return fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '?view=drawer' : '/cart?view=drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;

        drawer.classList.remove('is-empty');
        if (shouldOpen && typeof drawer.open === 'function') drawer.open();
      });
  }

  function handleAddonChange(input) {
    var addon = input.closest(SELECTORS.addon);
    if (!addon) return;

    var variantId = addon.getAttribute('data-variant-id');
    if (!variantId) return;

    var wasChecked = input.checked;
    addon.classList.add('is-busy');

    var request = wasChecked
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
      : fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        });

    request
      .then(function (response) {
        if (!response.ok) throw new Error('La petición al carrito falló');
        return response.json();
      })
      .then(function () {
        var settings = config();
        if (wasChecked && settings.cartType === 'page') {
          window.location.href = settings.cartUrl || '/cart';
          return;
        }
        // Al agregar se abre el cajon; al quitar solo se refresca en silencio.
        return refreshCartDrawer(wasChecked);
      })
      .catch(function () {
        input.checked = !wasChecked;
      })
      .finally(function () {
        addon.classList.remove('is-busy');
      });
  }

  /* ----------------------------------------------------------------
     Galeria

     El indice activo se deduce de la posicion de scroll del carril, asi que
     funciona igual si lo movio el dedo o una miniatura. No hay estado propio
     que pueda desincronizarse.
     ---------------------------------------------------------------- */

  function currentSlide(track) {
    if (!track || !track.clientWidth) return 0;
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function syncGallery() {
    var track = document.querySelector(SELECTORS.galleryTrack);
    if (!track) return;

    var index = currentSlide(track);
    var total = track.children.length;

    var counter = document.querySelector(SELECTORS.galleryCounter);
    if (counter) counter.textContent = index + 1 + '/' + total;

    var dots = document.querySelector(SELECTORS.galleryDots);
    if (dots) {
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    document.querySelectorAll(SELECTORS.galleryThumb).forEach(function (thumb) {
      var thumbIndex = parseInt(thumb.getAttribute('data-costa-gallery-thumb'), 10);
      thumb.classList.toggle('is-active', thumbIndex === index);
    });
  }

  function goToSlide(index) {
    var track = document.querySelector(SELECTORS.galleryTrack);
    if (!track) return;
    track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
  }

  function openLightbox() {
    var track = document.querySelector(SELECTORS.galleryTrack);
    var dialog = document.querySelector(SELECTORS.lightbox);
    var target = document.querySelector(SELECTORS.lightboxImg);
    if (!track || !dialog || !target) return;

    var slide = track.children[currentSlide(track)];
    var source = slide ? slide.querySelector('img') : null;
    if (!source) return;

    target.src = source.currentSrc || source.src;
    target.alt = source.alt || '';

    if (typeof dialog.showModal === 'function') dialog.showModal();
  }

  /*
    Zoom al pasar el cursor.

    Se mueve el punto de origen de la ampliacion al sitio exacto donde esta el
    raton, de modo que la zona que se mira crece bajo el cursor en lugar de
    escaparse hacia un lado. Solo se activa con raton de verdad: en tactil
    "hover" se dispararia con el primer toque y bloquearia el deslizamiento del
    carrusel.
  */
  function mountZoom() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var track = document.querySelector(SELECTORS.galleryTrack);
    if (!track || track.dataset.costaZoom) return;
    track.dataset.costaZoom = '1';

    var pending = null;

    track.addEventListener('mousemove', function (event) {
      var slide = event.target.closest('.costa-gallery__slide');
      if (!slide) return;

      if (pending) cancelAnimationFrame(pending);
      pending = requestAnimationFrame(function () {
        var box = slide.getBoundingClientRect();
        var x = ((event.clientX - box.left) / box.width) * 100;
        var y = ((event.clientY - box.top) / box.height) * 100;

        slide.style.setProperty('--costa-zoom-x', x.toFixed(2) + '%');
        slide.style.setProperty('--costa-zoom-y', y.toFixed(2) + '%');
        slide.classList.add('is-zooming', 'is-tracking');
      });
    });

    track.addEventListener('mouseover', function (event) {
      var slide = event.target.closest('.costa-gallery__slide');
      if (!slide) return;

      // Al entrar se deja la transicion puesta para que la ampliacion nazca
      // suave; is-tracking la quita en cuanto el raton empieza a moverse.
      slide.classList.remove('is-tracking');

      /*
        La pagina carga la foto al tamaño en que se ve (~546px). Ampliada 2,5x
        haria falta el triple, y se veria blanda. En vez de descargar de entrada
        una imagen enorme —que es la que marca el LCP de la pagina— se sube el
        atributo sizes la primera vez que el raton entra: el navegador elige
        entonces un candidato mayor del srcset que ya existe y lo cambia solo,
        sin parpadeo, mostrando el anterior mientras llega.
      */
      var img = slide.querySelector('img');
      if (img && img.srcset && !img.dataset.costaHiRes) {
        img.dataset.costaHiRes = '1';
        img.sizes = '1400px';
      }
    });

    track.addEventListener('mouseleave', function () {
      if (pending) cancelAnimationFrame(pending);
      track.querySelectorAll('.costa-gallery__slide').forEach(function (slide) {
        slide.classList.remove('is-zooming', 'is-tracking');
        slide.style.removeProperty('--costa-zoom-x');
        slide.style.removeProperty('--costa-zoom-y');
      });
    });
  }

  function mountGallery() {
    var track = document.querySelector(SELECTORS.galleryTrack);
    if (!track || track.dataset.costaBound) return;
    track.dataset.costaBound = '1';

    var frame = null;
    track.addEventListener(
      'scroll',
      function () {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(syncGallery);
      },
      { passive: true }
    );

    syncGallery();
  }

  /* ----------------------------------------------------------------
     Registro de escuchadores (una sola vez)
     ---------------------------------------------------------------- */

  function bindGlobalListeners() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;

      if (target.matches(SELECTORS.sizeInput)) {
        clearSizeError();
        syncSizeState();
        syncStickyButton();
        return;
      }

      if (target.matches(SELECTORS.addonInput)) {
        handleAddonChange(target);
      }
    });

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        if (target.closest(SELECTORS.guideOpen)) {
          event.preventDefault();
          openGuide();
          return;
        }

        var thumb = target.closest(SELECTORS.galleryThumb);
        if (thumb) {
          event.preventDefault();
          goToSlide(parseInt(thumb.getAttribute('data-costa-gallery-thumb'), 10));
          return;
        }

        if (target.closest(SELECTORS.galleryZoom)) {
          event.preventDefault();
          openLightbox();
          return;
        }

        if (target.closest(SELECTORS.lightboxClose)) {
          event.preventDefault();
          var lightbox = document.querySelector(SELECTORS.lightbox);
          if (lightbox && typeof lightbox.close === 'function') lightbox.close();
          return;
        }

        if (target.closest(SELECTORS.guideClose)) {
          event.preventDefault();
          closeGuide();
          return;
        }

        var stickyButton = target.closest(SELECTORS.stickyButton);
        if (stickyButton) {
          event.preventDefault();
          if (needsSize()) {
            showSizeError();
          } else {
            var cta = document.querySelector(SELECTORS.addButton);
            if (cta) cta.click();
          }
          return;
        }

        var moreReviews = target.closest('[data-costa-reviews-more]');
        if (moreReviews) {
          event.preventDefault();
          document.querySelectorAll('[data-costa-review-extra]').forEach(function (card) {
            card.hidden = false;
          });
          moreReviews.hidden = true;
          return;
        }

        var addButton = target.closest(SELECTORS.addButton);
        if (addButton && needsSize()) {
          // Se detiene aqui para que product-form.js ni siquiera vea el envio.
          event.preventDefault();
          event.stopPropagation();
          showSizeError();
        }
      },
      true
    );

    // Clic en el velo del dialogo: solo cuenta si cae fuera de la hoja.
    document.addEventListener('click', function (event) {
      var dialog = event.target.closest && event.target.closest(SELECTORS.guideDialog);
      if (!dialog) return;
      if (!event.target.closest('.costa-guide-dialog__sheet')) closeGuide();
    });
  }

  /* ----------------------------------------------------------------
     Arranque
     ---------------------------------------------------------------- */

  function mount() {
    if (!root()) return;
    syncSizeState();
    mountStickyBar();
    mountGallery();
    mountZoom();
  }

  if (!window.__costaPdpBound) {
    window.__costaPdpBound = true;
    bindGlobalListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
